/*
 * Copyright (c) 2018, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

/**
 * Helper function that watches the authenticate state, then applies it
 * as a boolean (authenticated) as well as attaches the userinfo data.
 */
import Cookies from 'js-cookie'
import jwtDecode from 'jwt-decode'
import { defaultLang, defaultToken, defaultLanguage, defaultAccount } from '@/utils/default'
const redirectURL = window.location.origin + (process.env.PUBLIC_URL || '') + '/login'
async function checkAuthentication() {
  let authenticated = false
  // authenticate SMT Token (for Nike external users)
  const shvOauthToken = Cookies.get(defaultToken) // get SHV generated token for external users
  try {
    const account = jwtDecode(shvOauthToken)
    authenticated = account ? true : false
  } catch (err) {
    // Invalid JWT token
    console.log(err)
    authenticated = false
  }
  if (authenticated !== this.state.authenticated) {
    this.setState({ authenticated })
  }
}

const clearAuthentication = () => {
  Cookies.remove(defaultToken)
  const language = localStorage.getItem(defaultLanguage)
  localStorage.clear()
  localStorage.setItem(defaultLanguage, language || defaultLang)
}

// authType: 0,1; 0 indicate internal user, 1 indicate external user;
const generateAuthHeader = async () => {
  let accessToken = Cookies.get(defaultToken) // get SHV generated token for external users
  return {
    Authorization: `Bearer ${accessToken}`,
    username: localStorage.getItem(defaultAccount)
  }
}

/* eslint-disable import/prefer-default-export */
export { generateAuthHeader, checkAuthentication, clearAuthentication, redirectURL }
